import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/index/s3.webp")